<app-header *ngIf="!newUI"></app-header>
<app-navbar *ngIf="newUI"></app-navbar>